import { render } from "./VideoJSPlayer.vue?vue&type=template&id=4488d33c"
import script from "./VideoJSPlayer.vue?vue&type=script&lang=js"
export * from "./VideoJSPlayer.vue?vue&type=script&lang=js"

import "./VideoJSPlayer.vue?vue&type=style&index=0&id=4488d33c&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__